import React, { useState, useRef } from "react";
import MainLayout from "../../Layout/mainLayout";
import { ReactComponent as Franchise } from "../../Global Icons/Franchise.svg";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import TextInput from "../../Global Functions/textInput";
import TwoButtons from "../../Global Functions/buttons";
import { addCancellationPolicy } from "../../Redux/Actions/cancellationPoliciesAction";
import { useNavigate } from "react-router-dom";
import "./add.css";
import { FaTrash } from "react-icons/fa";

const AddCancellationPolicy = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formState, setFormState] = useState({
    title: "",
    policy: [""],
    type: "dooritt", // or any default type
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleArrayChange = (field, index, value) => {
    const updatedArray = [...formState[field]];
    updatedArray[index] = value;
    setFormState((prev) => ({
      ...prev,
      [field]: updatedArray,
    }));
  };

  const handleAddArrayItem = (field) => {
    setFormState((prev) => ({
      ...prev,
      [field]: [...prev[field], ""],
    }));
  };

  const handleRemoveArrayItem = (field, index) => {
    const updatedArray = [...formState[field]];
    if (updatedArray.length > 1) {
      updatedArray.splice(index, 1);
      setFormState((prev) => ({
        ...prev,
        [field]: updatedArray,
      }));
    } else {
      toast.error("At least one item is required.");
    }
  };

  const handleSubmit = async () => {
    if (!formState.title.trim()) {
      return toast.error("Title is required");
    }
    if (!formState.policy.length) {
      return toast.error("At least one policy item is required");
    }
    for (let i = 0; i < formState.policy.length; i++) {
      if (!formState.policy[i].trim()) {
        return toast.error(`Policy item ${i + 1} cannot be empty`);
      }
    }
    const payload = { ...formState, policy: formState.policy.map(item => item.trim()) };
    try {
      const response = await dispatch(addCancellationPolicy(payload));
      if (response && (response.statusCode === 200 || response.status === "success")) {
        setFormState({ title: "", policy: [""], type: "dooritt" });
        navigate("/cancellation_policies");
      } else {
        toast.error(response.message || "Failed to add cancellation policy");
      }
    } catch {
      toast.error("Error submitting cancellation policy");
    }
  };


  return (
    <MainLayout>
      {/* Similar form layout, adjust for cancellation policy */}
      <div className="franchise-form-container">
        <div className="franchise-form-wrapper franchise-card">
          <div className="franchise-card-content">
            <div className="franchise-header">
              <div className="franchise-header-icon">
                <Franchise />
              </div>
              <h1>Add Cancellation Policy</h1>
            </div>
            <div className="form-section">
              <TextInput
                label="Title"
                name="title"
                value={formState.title}
                onChange={handleChange}
                required
                inputClass="form-input"
                labelClass="form-label"
              />
            </div>

            <div className="form-section">
              <label className="form-label" htmlFor="type_select">
                Type <span style={{ color: "red" }}>*</span>
              </label>
              <select
                id="type_select"
                name="type"
                value={formState.type}
                onChange={handleChange}
                className="form-input"
              >
                <option value="dooritt">dooritt</option>
                <option value="builder">Builder</option>
              </select>
            </div>
            {/* Terms & Conditions array input */}
            <div className="form-section">
              <label className="form-label">Policy</label>
              {formState.policy.map((term, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 8,
                  }}
                >
                  <TextInput
                    value={term}
                    onChange={(e) =>
                      handleArrayChange("policy", index, e.target.value)
                    }
                    inputClass="form-input"
                  />
                  <button
                    type="button"
                    onClick={() => handleRemoveArrayItem("policy", index)}
                    style={{
                      marginLeft: 8,
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#d9534f",
                    }}
                    aria-label="Remove policy item"
                  >
                    <FaTrash size={16} />
                  </button>
                </div>
              ))}
              <button
                type="button"
                onClick={() => handleAddArrayItem("policy")}
              >
                Add Policy Item
              </button>
            </div>
            {/* Submit and Cancel Buttons */}
            <div className="form-navigation">
              <button
                type="button"
                onClick={() => navigate("/cancellation_policies")}
              >
                Cancel
              </button>
              <TwoButtons onClick2={handleSubmit} buttonHead2="Save" />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddCancellationPolicy;
